import React from "react";
import { createRoot } from 'react-dom/client';
import { MapWidget } from "./components/mapWidget/MapWidget";
import { MinimalMapWidget } from "./components/mapWidget/MinimalMapWidget";
import { colors } from "./utils/map/mapUtils";

export const mount = (props) => {
    const container = document.getElementById(props.containerId)
    const root = createRoot(container);
    return root.render(<MapWidget {...props} />);
}

export const mountMinimalMap = (props) => {
    const container = document.getElementById(props.containerId);
    const root = createRoot(container);
    return root.render(<MinimalMapWidget {...props} />)
}

// couleurs de la légende de l'estimateur immobilier (page habitat)
export const immoColors = (codeInsee) => colors(codeInsee);
